import { adminTemplateState } from "../types/index";

export const initialState: adminTemplateState = {
  data: [],
  formData: {
    documentName: "",
    documentPath: "",
    mimeType: "",
    documentType: "",
    documentSize: "",
    templateCode: "",
    templateDescription: "",
    format: "",
    version: "",
  },
  loading: false,
  saving: false,
  error: "",
  isAddModalOpen: false,
};
